import { render, staticRenderFns } from "./ExitDialog.vue?vue&type=template&id=13bf9e8c"
import script from "./ExitDialog.vue?vue&type=script&lang=js"
export * from "./ExitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports